import { useMemo } from 'react';
import { Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { GridColDef } from '@mui/x-data-grid-pro';
import { dataGridCol } from '@shared/components/grid/common';
import { extractTextFromHTML } from '@shared/commonFunctions';
import { CommunicationType } from '../interfaces';

type TOneClickEditColumnsArgs = (args: {
  communicationTypeId: CommunicationType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClickVoicemailPreview: (voicemail: any) => void;
}) => { columns: GridColDef[] };

export const useOneClickEditColumns: TOneClickEditColumnsArgs = ({ communicationTypeId, onClickVoicemailPreview }) => {
  const columns = useMemo(() => {
    if (communicationTypeId === CommunicationType.Email) {
      const emailColumns: GridColDef[] = [
        dataGridCol('daysRangeEnd', {
          headerName: 'Day',
          flex: 0.6,
          minWidth: 100,
        }),
        dataGridCol('template name', {
          minWidth: 100,
          flex: 1.8,
          renderCell: (params) => params?.row?.template?.name,
        }),
        dataGridCol('template', {
          flex: 5,
          minWidth: 240,
          renderCell: (params) => extractTextFromHTML(params.value?.templateData || ''),
        }),
      ];

      return emailColumns;
    }
    if (communicationTypeId === CommunicationType.Voicemail) {
      const voiceColumns: GridColDef[] = [
        dataGridCol('daysRangeEnd', {
          headerName: 'Day',
          flex: 1,
          minWidth: 120,
        }),
        dataGridCol('file', {
          flex: 0.5,
          minWidth: 120,
          renderCell: (params: { value?: boolean }) => (params.value ? <CheckIcon /> : null),
        }),
        dataGridCol('preview', {
          flex: 2,
          minWidth: 120,
          renderCell: ({ row }) => (
            <Button
              component="label"
              variant={'contained'}
              onClick={() => onClickVoicemailPreview(row)}
            >
              Preview
            </Button>
          ),
        }),
        dataGridCol('upload', {
          flex: 2,
          minWidth: 120,
          renderCell: () => (
            <Button
              component="label"
              variant={'contained'}
            >
              Upload
              <input
                hidden
                accept="audio/*"
                type="file"
              />
            </Button>
          ),
        }),
      ];

      return voiceColumns;
    }

    const textColumns: GridColDef[] = [
      dataGridCol('daysRangeEnd', {
        flex: 0.4,
        minWidth: 100,
        headerName: 'Day',
      }),
      dataGridCol('template name', {
        minWidth: 100,
        flex: 1.8,
       renderCell: (params) => params?.row?.template?.name,
      }),
      dataGridCol('template', {
        flex: 5,
        minWidth: 240,
        renderCell: (params) => extractTextFromHTML(params.value?.body || ''),
      }),
    ];

    return textColumns;
  }, [onClickVoicemailPreview, communicationTypeId]);

  return { columns };
};
